var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.966,
    height: 20.805,
    viewBox: "0 0 24.966 20.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "checklist",
    d: "M27.216,15.318,17.229,25.3l-4.993-4.993,2.5-2.5,2.5,2.5,7.49-7.49ZM10.073,21.477,11.4,22.808H3.914A1.669,1.669,0,0,1,2.25,21.144V6.164A1.669,1.669,0,0,1,3.914,4.5H15.565a1.669,1.669,0,0,1,1.664,1.664V16.983L15.9,15.651a1.677,1.677,0,0,0-2.363,0l-3.462,3.5a1.658,1.658,0,0,0,0,2.346ZM7.243,7.829h8.322V6.164H7.243Zm0,3.329h8.322V9.493H7.243Zm0,3.329h4.993V12.822H7.243ZM5.579,16.151H3.914v1.664H5.579Zm0-3.329H3.914v1.664H5.579Zm0-3.329H3.914v1.664H5.579Zm0-3.329H3.914V7.829H5.579Z",
    transform: "translate(-2.25 -4.5)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistMenu);
export default __webpack_public_path__ + "static/media/ChecklistMenu.4da1c97fd9047ce8b2a089c004f6c99f.svg";
export { ForwardRef as ReactComponent };